import { LegalLayout, LegalSection } from "../components/LegalLayout";

const Table = ({ rows }) => (
  <div className="overflow-x-auto rounded-2xl border border-navy/10 bg-white">
    <table className="w-full text-left text-sm">
      <thead className="bg-navy text-xs uppercase tracking-wider text-gold">
        <tr>
          <th className="px-4 py-3 font-semibold">Traitement</th>
          <th className="px-4 py-3 font-semibold">Données</th>
          <th className="px-4 py-3 font-semibold">Finalité & base légale</th>
          <th className="px-4 py-3 font-semibold">Durée</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-navy/10 text-slate-700">
        {rows.map((r) => (
          <tr key={r[0]}>
            {r.map((c, i) => <td key={i} className="px-4 py-3 align-top">{c}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const ROWS = [
  ["Formulaire de contact / devis", "Nom, téléphone, email (facultatif), activité, formule, message", "Répondre à votre demande et établir un devis — mesures précontractuelles (art. 6.1.b RGPD)", "3 ans après le dernier contact"],
  ["Formulaire maintenance", "Nom, email, description de la modification", "Exécuter l'abonnement Maintenance + Hébergement — exécution du contrat", "Durée du contrat + 3 ans"],
  ["Paiement en ligne (Stripe)", "Email, montant, référence de transaction (données bancaires traitées par Stripe uniquement)", "Encaisser les prestations et abonnements — exécution du contrat, obligations comptables", "10 ans (pièces comptables)"],
  ["Emails transactionnels (Resend)", "Email, nom, contenu des notifications (confirmation, précisions, livraison, rappel de renouvellement, relance)", "Vous informer de l'avancement de votre projet — exécution du contrat / intérêt légitime", "Journal d'envoi : 1 an"],
  ["Analyse automatisée des demandes (IA)", "Contenu du message et champs du formulaire", "Pré-qualifier la demande et préparer le cahier des charges du site — intérêt légitime (aucune décision produisant d'effet juridique n'est prise automatiquement)", "Identique à la demande"],
  ["Espace propriétaire (/admin)", "Cookies de session techniques (httpOnly) du propriétaire uniquement", "Sécuriser l'accès à l'administration — intérêt légitime", "Session : 15 min à 7 jours"],
];

export default function Confidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité" updated="juin 2026" testId="legal-privacy-page">
      <LegalSection title="1. Qui sommes-nous ?">
        <p>
          Le responsable du traitement est <strong>site.com</strong> (SIRET 130 962 632 00019), joignable à{" "}
          <a href="mailto:site.com@outlook.fr" className="font-semibold text-navy hover:text-gold-dark">site.com@outlook.fr</a> ou au 07 84 67 88 02.
          Siège : 5 Bis Chemin du Juge de Paix, 69130 Écully. Responsable : Arthur Lefèvre, entrepreneur individuel.
        </p>
      </LegalSection>

      <LegalSection title="2. Quelles données traitons-nous, et pourquoi ?">
        <p>Nous ne collectons que les données nécessaires à la création et au suivi de votre site. Aucun profilage publicitaire n'est réalisé.</p>
        <Table rows={ROWS} />
      </LegalSection>

      <LegalSection title="3. Destinataires et sous-traitants">
        <p>Vos données ne sont jamais vendues. Elles sont traitées par site.com et, pour les seuls besoins décrits ci-dessus, par nos sous-traitants :</p>
        <ul className="list-disc space-y-1 pl-5">
          <li><strong>OVHcloud</strong> (France) — hébergement du site et des sites clients.</li>
          <li><strong>Stripe</strong> (Irlande / UE) — paiement sécurisé ; les données bancaires ne transitent jamais par nos serveurs.</li>
          <li><strong>Resend</strong> — envoi des emails transactionnels.</li>
          <li><strong>Fournisseur de modèle d'IA</strong> (OpenAI via une passerelle sécurisée) — analyse du texte de votre demande pour préparer le brief de votre site. Les données peuvent être traitées hors de l'Union européenne, encadrées par des clauses contractuelles types.</li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Cookies">
        <p>
          Le site public n'utilise <strong>aucun cookie de suivi ni de mesure d'audience</strong>. Seul l'espace propriétaire (/admin)
          dépose des cookies de session strictement nécessaires à la connexion, exemptés de consentement. Le paiement sur la page Stripe est
          soumis à la politique de cookies de Stripe.
        </p>
      </LegalSection>

      <LegalSection title="5. Vos droits">
        <p>
          Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement, de
          limitation, d'opposition et de portabilité de vos données, ainsi que du droit de définir des directives post-mortem. Pour l'exercer,
          écrivez à <a href="mailto:site.com@outlook.fr" className="font-semibold text-navy hover:text-gold-dark">site.com@outlook.fr</a> en précisant votre
          demande ; nous répondons sous un mois. Vous pouvez également introduire une réclamation auprès de la CNIL (
          <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="font-semibold text-navy hover:text-gold-dark">www.cnil.fr</a>).
        </p>
      </LegalSection>

      <LegalSection title="6. Sécurité">
        <p>
          Les échanges sont chiffrés (https), les accès à l'administration sont protégés par mot de passe haché et limitation des tentatives,
          et les données sont hébergées chez OVHcloud en France. Nous ne vous demanderons jamais votre mot de passe ou vos coordonnées bancaires par email.
        </p>
      </LegalSection>

      <LegalSection title="7. Mise à jour">
        <p>Cette politique peut évoluer ; la date de dernière mise à jour figure en haut de page. Toute modification substantielle vous sera signalée par email si vous êtes client.</p>
      </LegalSection>
    </LegalLayout>
  );
}
